<div class="input-group">
  <input
    class="form-control form-control--default form-control--time"
    type="text"
    [placeholder]="placeholder"
    [attr.name]="name"
    [(ngModel)]="value"
    mask="Hh:m0:s0"
    [leadZeroDateTime]="true"
    (blur)="onSelectTime()"
    [ngClass]="inputClass"
  />
  <button
    class="btn time-picker-btn"
    (click)="openPicker(p1)"
    [ngbPopover]="popContent"
    [container]="container"
    #p1="ngbPopover"
    placement="bottom"
    triggers="manual"
    [autoClose]="'outside'"
    type="button"
  >
    <i class="iconFont iconFont-clock"></i>
  </button>
</div>

<ng-template #popContent let-greeting="greeting">
  <ngb-timepicker [(ngModel)]="value" [seconds]="true"></ngb-timepicker>
</ng-template>
<!-- <ng-template #popTitle let-language="language">My Title</ng-template> -->
